var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3235 20.8556C19.6092 20.6187 19.883 20.3683 20.1449 20.1042M18.3065 12.0099C18.3051 10.4291 17.7104 8.90641 16.64 7.74311C15.5697 6.57981 14.1017 5.86063 12.5265 5.72787C10.9513 5.59511 9.38365 6.05844 8.13371 7.02618C6.88377 7.99392 6.0426 9.39558 5.77662 10.9538C5.51065 12.5121 5.83925 14.1134 6.69741 15.441C7.55557 16.7686 8.88077 17.7257 10.4108 18.1229C11.9409 18.5202 13.5643 18.3287 14.9599 17.5863C16.3555 16.8439 17.4217 15.6047 17.9473 14.1139C18.1859 13.4381 18.307 12.7266 18.3065 12.0099Z",
    stroke: "#39322F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4801 12.0099C23.4832 10.2282 23.0719 8.47022 22.2787 6.87482C21.4855 5.27943 20.3321 3.89035 18.9098 2.81735C17.4874 1.74434 15.835 1.01682 14.0831 0.692254C12.3313 0.36769 10.5279 0.454982 8.81557 0.947231C7.10323 1.43948 5.52882 2.3232 4.21675 3.52856C2.90467 4.73392 1.89089 6.2279 1.2555 7.89245C0.620102 9.557 0.38051 11.3465 0.55565 13.1196C0.730791 14.8926 1.31586 16.6007 2.26464 18.1087L1.55173 22.4483L5.89122 21.7353C7.45354 22.7197 9.23055 23.3121 11.071 23.4621C12.9115 23.6121 14.761 23.3153 16.4621 22.5968",
    stroke: "#39322F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9463 14.113C17.1746 15.9952 18.431 17.008 19.5121 17.2538C20.8306 17.5531 23.4802 16.1748 23.4802 12.0095",
    stroke: "#39322F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7cb29bc3e021f9063685513e8b10f73d.svg";
export { ForwardRef as ReactComponent };